/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Architect_Detail9Inputs */

const en_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates, content rules and crawl budget plan.`)
};

const ar_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القوالب وقواعد المحتوى وخطة ميزانية الزحف.`)
};

const bn_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টেমপ্লেট, কনটেন্ট নিয়ম আর ক্রল বাজেট পরিকল্পনা।`)
};

const de_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen, Inhaltsregeln und Crawl-Budget-Plan.`)
};

const es_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantillas, reglas de contenido y plan de presupuesto de rastreo.`)
};

const fr_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèles, règles de contenu et plan de budget de crawl.`)
};

const pt_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos, regras de conteúdo e plano de crawl budget.`)
};

const zh_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板、内容规则和抓取预算计划。`)
};

const tr_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şablonlar, içerik kuralları ve tarama bütçesi planı.`)
};

const ru_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблоны, правила контента и план краул-бюджета.`)
};

const pl_svc_programmatic_seo_architect_detail9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatki, reguły treści i plan budżetu crawlowania.`)
};

/**
* | output |
* | --- |
* | "Templates, content rules and crawl budget plan." |
*
* @param {Svc_Programmatic_Seo_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_architect_detail9 = /** @type {((inputs?: Svc_Programmatic_Seo_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "de") return de_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "es") return es_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_architect_detail9(inputs)
	return en_svc_programmatic_seo_architect_detail9(inputs)
});
export { svc_programmatic_seo_architect_detail9 as "svc_programmatic-seo_ARCHITECT_detail" }